import { ExternalLink } from 'lucide-react';
import { dayMonth, euro } from '../lib/api';
import type { ClosedDeal } from '../../shared/kpi';

/**
 * Liste der Abschlüsse – gewonnen oder verloren.
 *
 * Zwei Dinge sind hier bewusst:
 *
 * 1. **Der Kunde steht vor dem Deal-Namen.** Namen wie „4x BP-60C31" oder
 *    „Projekt 2026" sind ohne Kunde nicht zuzuordnen.
 * 2. **Fehlende Beträge werden benannt**, nicht als 0 € dargestellt. `Amount`
 *    ist im CRM nur teilweise gefüllt; „0 €" liest sich wie „nichts wert"
 *    statt „nicht erfasst".
 */
export function ClosedList({ deals, kind }: { deals: ClosedDeal[]; kind: 'won' | 'lost' }) {
  if (deals.length === 0) {
    return (
      <p className="card__meta">
        {kind === 'won' ? 'Diesen Monat noch nichts gewonnen.' : 'Diesen Monat nichts verloren.'}
      </p>
    );
  }
  return (
    <div className="sm-stale">
      {deals.map((d) => (
        <div className="sm-stale__row" key={d.id}>
          <span>
            <span className="sm-stale__customer">{d.customer ?? 'ohne Kunde'}</span>
            <br />
            {d.url ? (
              <a href={d.url} target="_blank" rel="noreferrer noopener" className="linkbtn">
                {d.name} <ExternalLink size={12} />
              </a>
            ) : (
              d.name
            )}
            {kind === 'lost' && d.lostReason ? (
              <span className="card__meta"> · Grund: {d.lostReason}</span>
            ) : null}
          </span>
          <span className="mono" style={{ whiteSpace: 'nowrap' }}>
            {d.closedOn ? dayMonth(d.closedOn) : '–'}
            {d.amount !== null ? (
              <span className={kind === 'won' ? 'sm-amount--won' : 'card__meta'}> · {euro(d.amount)}</span>
            ) : (
              <span className="card__meta"> · kein Betrag</span>
            )}
          </span>
        </div>
      ))}
    </div>
  );
}
